(function () {
	'use strict';

	angular
		.module('app')
		.controller('nextMenuController', nextMenuController);

	function nextMenuController(viewModel, homeService) {
		var vm = this;
		vm.getMoreList = getMoreList;
		var currentPage = 1;
		init();

		function init() {
			vm.menuSerilNo = getMenuQueryString();
			vm.data = viewModel.data;
			vm.currentPage = 1;
		}

		function getMoreList() {
			currentPage++;
			homeService.getNextMore(currentPage).then(function (data) {
				vm.data.hasMore = data.data.hasMore;
				vm.data.bulletins.bulletins = _.concat(vm.data.bulletins.bulletins, data.data.bulletins.bulletins);
			});
		}
	}
})();